/* eslint-disable */
export default {
  // logging: 'Logging...',
  // logCall: 'Log Call',
  // editLog: 'Edit Log',
  // select: 'Select a matching record',
  // OnHold: 'On Hold',
  // Ringing: 'Ringing',
  // CallConnected: 'Call Connected',
  // unknownUser: 'Unknown User',
  // unknownNumber: 'Anonymous',
  // unavailable: 'Unavailable',
  // viewDetails: 'View Details',
  // addEntity: 'Create New',
  // addLog: 'Log',
  // text: 'Text',
  // call: 'Call',
  // addContact: 'Add Contact',
  missedCall: '부재중 전화',
  inboundCall: '수신',
  outboundCall: '발신',
  // from: 'From',
  // to: 'To',
  // hangup: 'Hangup',
  // accept: 'Accept',
  // toVoicemail: 'Send to Voicemail',
  // anonymous: 'Anonymous',
  // mergeToConference: 'Merge',
  // hold: 'Hold',
  // unhold: 'Unhold',
} as const;

// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
